var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vertical-bar-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.chartOptions,"height":280}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }